import { useState } from "react";
import { FiSettings } from "react-icons/fi";
import AccountSidebar from "./AccountSidebar";
import UserManagementData from "./UserManagement/UserManagementData";
import DesignationManagementData from "./DesignationManagement/DesignationManagementData";
import InvitationManagement from "./InvitationManagement/InvitationManagement";
import SetupAnothetAccount from "./ManageAnotherAccount/SetupAnothetAccount";
import ManageProfile from "./ProfileManagement/ManageProfile";
import ChangePassword from "./ProfileManagement/ChangePassword";
import TwoFactorAuth from "./ProfileManagement/TwoFactorAuth";
import SetupAnotherDevice from "./ProfileManagement/SetupAnotherDevice";
import LinkedDevices from "./ProfileManagement/LinkedDevices";
import LoginHistory from "./ProfileManagement/LoginHistory";
import BruteForceAttackRecord from "./ProfileManagement/BruteForceAttackRecord";

const AccountManagement = () => {
  const [openAdminModules, setOpenAdminModules] = useState("userManagement");

  return (
    <>
      <aside className="channels-panel border-end">
        <div className="channels-header pt-3 px-2">
          <strong>Work Bridge</strong>
          <FiSettings />
        </div>
        <AccountSidebar
          setOpenAdminModules={setOpenAdminModules}
          openAdminModules={openAdminModules}
        />
      </aside>
      <div className="chat-wrapper">
        <div className="chat-main">
          {openAdminModules === "userManagement" && <UserManagementData />}
          {openAdminModules === "designationManagement" && <DesignationManagementData />}
          {openAdminModules === "invitationManagement" && <InvitationManagement />}
          {openAdminModules === "setupAccount" && <SetupAnothetAccount />}
          {openAdminModules === "manageProfile" && <ManageProfile />}
          {openAdminModules === "changePassword" && <ChangePassword />}
          {openAdminModules === "twoFactorAuthentication" && <TwoFactorAuth />}
          {openAdminModules === "setupAnotherDevices" && <SetupAnotherDevice />}
          {openAdminModules === "linkedDevices" && <LinkedDevices />}
          {openAdminModules === "loginHistory" && <LoginHistory />}
          {openAdminModules === "bruteforceAttack" && <BruteForceAttackRecord />}
        </div>
      </div>
    </>
  );
};

export default AccountManagement;
